module.exports = __webpack_public_path__ + "static/media/listing-icon-active.99129326.svg";